import Vue from 'vue';
import deepmerge from 'deepmerge';
const Message = Vue.prototype.$message;

function isFunc(ins) {
	return typeof ins ==='function';
}
function isString(str) {
	return typeof str === 'string';
}

/**
 * @method：validateElForm
 * @createdBy:HuangJian
 * @date:2019/4/3
 * @params：
 * @description：用于elForm的表单验证
 */
function validateElForm(form) {
	if (!form) {
		Message.error('缺少表单实例！');
		return;
	}
	return !(form.fields || []).find((t)=>{
		let msg = '';
		t.validate('', (s)=> msg = s);
		const pass = Boolean(msg);
		if(pass){
			msg = msg.trim() || t.fieldValue ? '校验不通过' : '不能为空';
			Message.error(`${t.label}：${msg}`);
		}
		return pass;
	});
}

/*所有DATA变量*/
const DATA_VARS = {
	title: '', //标题
	id: '', //记录id
	isEditing: false, //是否正在编辑
	isInsert: false, //是否为新建
	isSaving: false, //是否正在保存
	module: '', //接口模块
	data: {}, //表单对象
	dataBackup: {}, //表单对象备份
	dataDefault: {}, //表单默认值
	gridCols: 1, //自动分列
	elForm: [], //el-form表单组件实例集合
	elFormProps:  null, //自定义的el-form原生属性
	showLoading: false,  // 是否启用loading遮罩
	isBusy: false, // 当前是否处在忙碌状态
	cancelConfirm: false, // 取消时是否给出一个确认提示
	freshListOnBack: false, //是否自动判断在返回上一个页面后刷新列表
	firstCancelBack: false, //是否在首次取消编辑后返回之前的页面
	isFirstCancelValid: false, //是否符合首次取消编辑后返回的条件
	operateTimes: 0, //操作次数
	disabledFields: [], //禁用的字段
	formPanel: [], //lnk-form-panel实例集合
	loadPreDefault: true, //新建时是否预取一个id
	preDefaultUrl: null, //新建预取id的自定义接口链接
	loadOnStart: false, //是否在组件加载时查询数据
	loadMethod: null, //自定义加载方法
	queryUrl: '', //自定义接口查询url
	sendByJson: true, //是否通过json发起请求
	insertUrl: null, //自定义新建接口地址
	upsertUrl: null, //自定义新建/更新接口地址
	updateUrl: null, //自定义更新接口的保存方法
	deleteUrl: null, //自定义删除接口的保存方法
	saveMethod: null, //自定义保存方法
	beforeEnableInsert: null, //钩子函数，打开新建模式前触发
	beforeSave: null, //钩子函数，执行保存前触发
	beforeDelete: null, //钩子函数，执行删除前触发
	onLoadSuccess: null, //钩子函数，查询数据成功时触发
	onLoadError: null, //钩子函数，查询数据出错时触发
	onSaveSuccess: null, //钩子函数，保存成功后触发,
	onSaveError: null, //钩子函数，保存失败后触发
	autoOption: null  //用来兼容父子列表AutoOption实例
}

/*全局默认值*/
const DEFAULT_PROPS = {
	gridCols: 1, //自动分列
	elFormProps: { //自定义的el-form原生属性
		size: 'mini',
		labelSuffix: '：'
	},
	cancelConfirm: true, // 取消时是否给出一个确认提示
	showLoading: true,  // 是否启用loading遮罩
	freshListOnBack: true, //是否自动判断在返回上一个页面后刷新列表
	firstCancelBack: true, //是否在首次取消编辑后返回之前的页面
	loadPreDefault: true, //新建时是否预取一个id
	loadOnStart: true, //是否在组件加载时查询数据
	sendByJson: true, //是否通过json发起请求
	onSaveSuccess(resp){ //钩子函数，保存成功后触发
		this.$message.success('保存成功！');
	}
};

/*复制操作默认排除的字段*/
const COPY_EXCLUDE_KEYS = [
	'id',
	'created',
	'lastUpdated',
	'createdBy',
	'lastUpdatedBy',
	'basicOrgId',
	'basicPostnId',
	'login',
	'loginCorpId',
	'corpid',
	'orgId',
	'postnId'
];

const CONTROLLER = {
	computed: {
		/*是否单列*/
		isSingleCol(){
			return this.gridCols <= 1;
		}
	},
	watch: {
		'elForm.fields'() {
			this.disableFields();
		},
		'data.id'(idStr){
			if(idStr !== this.id) {
				this.id = idStr;
			}
			this.freshAutoOption(this.isInsert);
		},
		id(idStr) {
			if (!idStr || idStr === this.data.id) return;
			this.loadById(idStr);
		},
		disabledFields(fields){
			this.disableFields(fields);
		},
		isEditing(value){
			this.operateTimes+=value?1:0;
			if(this.operateTimes>1){
				this.isFirstCancelValid = false;
			}
		},
		isBusy(v){
			if(!this.showLoading) return;
			let nav = null;
			(nav = this.getNav()) && nav.loading(v);
		},
		isSingleCol(){
			this.freshGrid();
		}
	},
	methods: {
		/**
		 * @method：rqst
		 * @createdBy:黄健
		 * @date: 2020-12-22
		 * @params:：
		 * @description: 请求方法
		 */
		async request(){
			return await this.context.$http.post(...arguments);
		},
		/**
		 * @method：onError
		 * @createdBy：黄健
		 * @date：2020-02-07
		 * @params：
		 * @description：出错处理函数
		 */
		onError(e){
			if(this.$nav){
				this.$nav.error(String(e.message));
			}else{
				this.$message.error(String(e.message));
				linkLog.error(e);
			}
		},
		/**
		 * @method：bindElForm
		 * @createdBy:HuangJian
		 * @date:2019/11/26
		 * @params：
		 * @description：绑定el-form
		 */
		bindElForm(v){
			if((v || {})._isVue && v.$getComponentName() !== 'el-form') return;
			if(this.elForm.indexOf(v)<0){
				this.elForm.push(v);
			}
		},
		/**
		 * @method：unBindElForm
		 * @createdBy:黄健
		 * @date: 2020-12-11
		 * @params:：
		 * @description: 解除el-form绑定
		 */
		unBindElForm(v){
			const index = this.elForm.indexOf(v);
			if(index < 0) return;
			this.elForm.splice(index, 1);
		},
		/**
		 * @method：getElForms
		 * @createdBy:HuangJian
		 * @date:2019/11/26
		 * @params：
		 * @description：获取所有的el-form实例
		 */
		getElForms(){
			const list = [...this.elForm];
			this.formPanel.forEach((t)=> (t = t.$refs.elForm) && list.push(t));
			return list;
		},
		/**
		 * @method：bindFormPanel
		 * @createdBy:HuangJian
		 * @date:2019/12/9
		 * @params：
		 * @description：绑定 lnk-form-panel
		 */
		bindFormPanel(v){
			if((v || {})._isVue && v.$getComponentName() !== 'lnk-form-panel') return;
			if(this.formPanel.indexOf(v)<0){
				this.formPanel.push(v);
			}
		},
		/**
		 * @method：unBindFormPanel
		 * @createdBy:黄健
		 * @date: 2020-12-11
		 * @params:：
		 * @description: 解除lnk-form-panel的绑定
		 */
		unBindFormPanel(v){
			const index = this.formPanel.indexOf(v);
			if(index < 0) return;
			this.formPanel.splice(index, 1);
		},
		/**
		 * @method：freshGrid
		 * @createdBy:黄健
		 * @date: 2020-12-11
		 * @params:：
		 * @description: 刷新栅格
		 */
		freshGrid(){
			const ctxs = [];
			this.formPanel.forEach(({itemCtxs})=> {
				Object.keys(itemCtxs).forEach((i)=> ctxs.indexOf(i = itemCtxs[i]) < 0 && ctxs.push(i));
			});
			ctxs.forEach((ctx)=> ctx.$forceUpdate());
		},
		/**
		 * @method：getNav
		 * @createdBy:黄健
		 * @date: 2020-12-22
		 * @params:：
		 * @description: 获取当前绑定的NAV服务
		 */
		getNav(){
			const p = this.formPanel[0] || this.getElForms()[0];
			return p ? p.$nav : null;
		},
		/**
		 * @method：emit
		 * @createdBy:HuangJian
		 * @date:2019/12/9
		 * @params：
		 * @description：派发事件
		 */
		emit(...args){
			this.$emit(...args);
			this.formPanel.forEach((panel) => {
				if(panel instanceof Vue) {
					panel.$emit(...args);
				}
			});
		},
		/**
		 * @method：loadPreDefaultVal
		 * @createdBy:HuangJian
		 * @date:2019/11/26
		 * @params：
		 * @description：从接口预取一个默认对象
		 */
		async loadPreDefaultVal(){
			let result = {};
			const url = this.preDefaultUrl || `${this.module}/preDefaultValue`;
			try {
				const resp = await this.request(url, {});
				if(resp.success){
					result = resp.result;
				}else throw new Error();
			}catch (e) {
				throw new Error('在预取新纪录ID时发生错误！');
			}
			return result;
		},
		/**
		 * @method：doInsert
		 * @createdBy:HuangJian
		 * @date:2019/11/26
		 * @params：
		 * @description：打开新建
		 */
		async doInsert(){
			if(!this.id && this.operateTimes === 0){
				this.isFirstCancelValid = true;
			}
			this.isInsert = true;
			this.isEditing = true;
			try {
				const preDefault = this.loadPreDefault ? await this.loadPreDefaultVal() : {};
				const dataDefault = isFunc(this.dataDefault) ? await this.dataDefault() : this.dataDefault;
				const newRow = Object.assign({}, dataDefault, {id: preDefault.id});
				isFunc(this.beforeEnableInsert) && await this.beforeEnableInsert(newRow, preDefault);
				this.dataBackup = this.data;
				this.data = newRow;
				this.$nextTick(() => this.clearValidate());
			}catch (e) {
				this.isInsert = false;
				this.isEditing = false;
				this.onError(e);
			}
		},
		/**
		 * @method：doCopy
		 * @createdBy:HuangJian
		 * @date:2019/12/2
		 * @params id：记录id
		 * @description：拷贝记录
		 */
		async doCopy(sId){
			if(!this.id && this.operateTimes === 0){
				this.isFirstCancelValid = true;
			}
			this.isInsert = true;
			this.isEditing = true;
			try {
				let rawData = this.$lv.$utils.deepCopy(this.data);
				sId = isString(sId) && sId || rawData.id;
				if(sId !== rawData.id){
					const {result, success} = await this.fGetById(sId);
					rawData = success ? result : data;
				}
				COPY_EXCLUDE_KEYS.forEach((key) => delete rawData[key]);
				let preDefault = this.loadPreDefault ? await this.loadPreDefaultVal() : {};
				const newRow = Object.assign({}, rawData, {id: preDefault.id});
				isFunc(this.beforeEnableInsert) && await this.beforeEnableInsert(newRow, preDefault);
				this.dataBackup = this.data;
				this.data = newRow;
				this.$nextTick(() => this.clearValidate());
			}catch (e) {
				this.isInsert = false;
				this.isEditing = false;
				this.onError(e);
			}

		},
		/**
		 * @method：doUpdate
		 * @createdBy:HuangJian
		 * @date:2019/11/26
		 * @params id：记录id
		 * @description：打开编辑
		 */
		doUpdate(id){
			if(!this.id && this.operateTimes === 0){
				this.isFirstCancelValid = true;
			}
			if(id && isString(id)){
				this.id = id;
			}
			this.dataBackup = this.data;
			this.data = this.$lv.$utils.deepCopy(this.data);
			this.isInsert = false;
			this.isEditing = true;
			this.$nextTick(() => this.clearValidate());
		},
		/**
		 * @method：doDelete
		 * @createdBy:黄健
		 * @date:2020/1/19
		 * @params id：行记录
		 * @description：删除操作
		 */
		async doDelete(id=null){
			try {
				id = isString(id) && id || this.data.id;
				if(!id){
					throw new Error('删除数据时缺少记录ID!');
				}
				let cancelFlag = false;
				const url = this.deleteUrl || `${this.module}/deleteById`;
				const rqst = {
					url,
					data: {id},
					cancel: () => cancelFlag = true
				};
				isFunc(this.beforeDelete) && this.beforeDelete(rqst);
				if(cancelFlag) return;
				const resp = await this.request(rqst.url, rqst.data, !this.sendByJson);
				if(!resp.success) throw new Error(resp.result || resp.message || resp.msg || '系统错误！');
				this.$message.success('已删除！');
				this.emit('deleted');
			}catch (e) {
				this.onError(e);
				return false;
			}
			return true;
		},
		/**
		 * @method：closeEdit
		 * @createdBy:HuangJian
		 * @date:2019/11/26
		 * @params：
		 * @description：关闭编辑
		 */
		async closeEdit(){
			if(this.isSaving){
				this.$message.info('正在保存数据，请勿取消...');
				return;
			}

			/*取消的确认提示*/
			if(this.cancelConfirm){
				try {
					await this.$confirm('确定要取消本次编辑吗！', '提示', {type: 'warning'});
				}catch (e) {
					return;
				}
			}

			/*第一次从列表跳转到表单新建页面，取消后回退*/
			if(this.firstCancelBack && this.isFirstCancelValid && this.operateTimes === 1){
				let nav = null;
				(nav = this.getNav()) && nav.back();
			}

			this.isInsert = false;
			this.isEditing = false;
			this.data = this.dataBackup;
			this.$nextTick(() => this.clearValidate());
		},
		/**
		 * @method：disableFields
		 * @createdBy:HuangJian
		 * @date:2019/12/2
		 * @params fields：el-form-item的label或prop值，可以是数组
		 * @description：按给定的标签或字段名强制禁用表单项
		 */
		disableFields(fields){
			const elForms = this.getElForms();
			if(!elForms.length) {
				throw new Error('当前FormOption未绑定表单实例!');
			}
			if(!fields) fields =[];
			if(!Array.isArray(fields)){
				fields = [fields];
			}
			const disabledFields = this.disabledFields;
			if(fields.length){
				fields.forEach((field) => disabledFields.indexOf(field)<0 && disabledFields.push(field));
			}
			elForms.forEach((v)=>{
				const formItems = v.$getChildComponent('el-form-item', false);
				formItems.forEach((item) => {
					const field = disabledFields.find((t) => item.label === t || item.prop === t);
					item.isForceDisabled = Boolean(field);
				});
			})
		},
		/**
		 * @method：enableFields
		 * @createdBy:HuangJian
		 * @date:2019/12/2
		 * @params fields：el-form-item的label或prop值，可以是数组
		 * @description：按给定的标签或字段名取消相关表单项的强制禁用
		 */
		enableFields(fields){
			const elForms = this.getElForms();
			if(!elForms.length) {
				throw new Error('当前FormOption未绑定表单实例!');
			}
			if(!Array.isArray(fields)){
				fields = [fields];
			}
			this.disabledFields = this.disabledFields.filter((field) => fields.indexOf(field)<0);
		},
		/**
		 * @method：clearValidate
		 * @createdBy:HuangJian
		 * @date:2019/12/2
		 * @params：
		 * @description：清楚校验
		 */
		clearValidate(){
			this.getElForms().forEach((t) => t.clearValidate());
		},

		/**
		 * @method：checkValid
		 * @createdBy:HuangJian
		 * @date:2019/12/2
		 * @params：
		 * @description：校验表单
		 */
		checkValid(){
			const elForms = this.getElForms();
			if(!elForms.length) {
				throw new Error('当前FormOption未绑定表单实例!');
			}
			const isValid = elForms.every((t) => validateElForm(t));
			if(isValid) {
				elForms.forEach((t) => t.clearValidate());
			}
			return isValid;
		},
		/**
		 * @method：markListFreshOnBack
		 * @createdBy:黄健
		 * @date: 2020-11-12
		 * @params:：
		 * @description: 标记表单返回上一个后刷新列表
		 */
		markListFreshOnBack(){
			if(!this.freshListOnBack) return;
			const formPanel = this.formPanel[0];
			if(!formPanel) return;
			if(!formPanel.$nav) return;
			formPanel.$nav.freshListOnBack();
		},
		/**
		 * @method：save
		 * @createdBy:HuangJian
		 * @date:2019/12/2
		 * @params：
		 * @description：保存数据
		 */
		async save(){
			if(this.isSaving) return false;
			if(!this.checkValid()) return false;
			this.isSaving = true;
			this.$nextTick(() => this.clearValidate());
			const operation = this.isInsert?'insert':'update';
			const isInsert = this.isInsert;
			let isSuccess = false;
			try {
				if(isFunc(this.saveMethod)){
					await this.saveMethod(this);
				}else {
					const diyUrl = this.isInsert ? this.insertUrl : this.updateUrl;
					let url = diyUrl || this.upsertUrl || `${this.module}/upsert`;
					let cacelFlag = false;
					let data = Object.assign({}, this.data);
					const rqst = {
						url,
						data,
						operation,
						cancel: () => cacelFlag = true
					};
					isFunc(this.beforeSave) && await this.beforeSave(rqst);
					if(cacelFlag){
						this.isSaving = false;
						return false;
					}
					/*如果是upsert类接口*/
					if(!diyUrl){
						rqst.data.row_status = this.isInsert ? 'NEW' : 'UPDATE';
					}
					const resp = await this.request(rqst.url, rqst.data, !this.sendByJson);
					if(!resp.success) throw new Error(resp.result || resp.message || resp.msg || '系统错误！');
					const newResp = isFunc(this.onSaveSuccess) && await this.onSaveSuccess(resp) || resp;
					this.data = newResp.newRow;
				}
				if(this.isInsert) this.freshAutoOption();
				this.isEditing = false;
				this.isInsert = false;
				isSuccess = true;
				this.emit('saved', {data: this.data, isInsert});
				this.markListFreshOnBack();
			}catch (e) {
				this.onError(e);
				this.emit('save-error', e);
				isFunc(this.onSaveError) && this.onSaveError(e);
			}
			this.isSaving = false;
			return isSuccess;
		},
		/**
		 * @method：_getById
		 * @createdBy:黄健
		 * @date: 2020-11-10
		 * @params:：
		 * @description: 根据id请求数据
		 */
		async fGetById(id){
			const url = this.queryUrl || `${this.module}/queryById`;
			return isFunc(this.loadMethod)
				? await this.loadMethod(id)
				: await this.request(url, {id});
		},
		/**
		 * @method：loadById
		 * @createdBy:HuangJian
		 * @date:2019/12/2
		 * @params：
		 * @description：根据id加载详细信息
		 */
		async loadById(id) {
			id = isString(id) && id;
			let rs = null;
			try {
				if(!id){
					throw new Error('查询数据时缺少ID！');
				}
				let resp = await this.fGetById(id);
				if(!resp.success) throw new Error(resp.result || resp.message || resp.msg || '系统错误！');
				const newResp = isFunc(this.onLoadSuccess) && await this.onLoadSuccess(resp) || resp;
				this.emit('loaded', newResp);
				rs = this.data = this.dataBackup = newResp.result || {};
				this.$nextTick(() => this.clearValidate());
			} catch (e) {
				this.emit('load-error', e);
				this.onError(e);
				isFunc(this.onLoadError) && this.onLoadError(e);
			}
			return rs;
		},
		/**
		 * @method：freshAutoOption
		 * @createdBy:黄健
		 * @date:2020/10/9
		 * @params：
		 * @description：刷新autoOption
		 */
		freshAutoOption(disable=false){
			const {autoOption} = this;
			if(disable){
				autoOption.list = [];
			}else {
				autoOption.list = [this.data];
			}
			autoOption.selectIndex = 0;
			autoOption.$emit('selectChange');
		},
		/**
		 * @method：reload
		 * @createdBy:HuangJian
		 * @date:2019/12/2
		 * @params：
		 * @description：重新加载详细信息
		 */
		reload(){
			this.loadById(this.id);
		},
		/**
		 * 重置表单对象
		 * @date 2020/12/02
		 * @author yrf
		 */
		reset() {
			this.data = this.$lv.$utils.deepCopy(this.dataBackup);
		}
	},
	created() {
		/*给指定函数植入loading监测*/
		['doInsert','doCopy','doDelete','save','loadById'].forEach((key)=>{
			if(!isFunc(this[key])) return;
			const rawMethod = this[key];
			const self = this;
			this[key] = async function(){
				self.isBusy = true;
				let rs = null;
				try {
					rs = await rawMethod.apply(self, arguments);
				}catch (e) {
					console.error(e);
				}
				self.isBusy = false;
				return rs;
			}
		});

		if(this.loadOnStart){
			const id = isString(this.id) && this.id;
			if(id) this.loadById(id);
		}
	}
};


export class FormOption extends Vue {

	constructor(opts={}, context) {
		let options = Object.assign({}, DATA_VARS, DEFAULT_PROPS);
		options = deepmerge(options, opts, {clone: true});
		const config = {
			data(){
				options.autoOption = new AutoOption({context: this});
				// 使用当前FormOption实例的Vue组件上下文
				options.context = context || this
				return options;
			},
			parent: context,
			...CONTROLLER
		};
		super(config);
	}

	/*用于自定义FormOption的默认值*/
	static setDefaultOptions = function(callback){
		if(!isFunc(callback)) return;
		callback(DEFAULT_PROPS);
	}

	static validateElForm = validateElForm;
}
